namespace RedBullMOBILE360.Sms {
    export interface ExclusiveOffersForm {
        OfferId: Serenity.StringEditor;
        ExclusiveOfferId: Serenity.StringEditor;
        IsEnabled: Serenity.BooleanEditor;
    }

    export class ExclusiveOffersForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.ExclusiveOffers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExclusiveOffersForm.init)  {
                ExclusiveOffersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(ExclusiveOffersForm, [
                    'OfferId', w0,
                    'ExclusiveOfferId', w0,
                    'IsEnabled', w1
                ]);
            }
        }
    }
}
